import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import styles from './DashboardOld.module.scss';

import Loader from "../../components/Loader/Loader";
import {
  getApplicationDataIsLoading, getApplicationDataHasFailed
} from "../../redux/modules/applicationData/applicationData.selectors";
import { initDashboardServiceCalls } from "../../services/index";
import MainLayout from '../../components/DashboardLayout/Old/MainLayout';
import ErrorPage from "../landing/ErrorPage";
import {clearShoppingCart} from "../../redux/modules/shoppingCart/shoppingCart.module";

const Destination = () => {
  const isLoading = useSelector(getApplicationDataIsLoading);
  const dispatch = useDispatch();
  const deleteProcessing = useSelector((state) => state.RMDSetting.deleteLoading);
  const hasError = useSelector(getApplicationDataHasFailed);

  /* eslint-disable */
  useEffect(() => {
    initDashboardServiceCalls(dispatch);
    dispatch(clearShoppingCart());
  }, []);
  /* eslint-enable */

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Loader isVisible={true} />
      </div>
    );
  }

  if (hasError) {
    return <ErrorPage />;
  }

  return (
    <div className={styles["container"]}>
      {deleteProcessing &&
      <div className={styles["delete-loading"]}>
        <Loader isVisible={true}/>
      </div>
      }
      <MainLayout />
    </div>
  );
};

export default Destination;
